import { ButtonHTMLAttributes } from 'react';
import { Button, EXTRA_SMALL, SECONDARY } from '@glu/buttons-react';
import { Locale } from '@glu/locale-react';
import classNames from 'classnames';
import { Typography } from '@glu/typography-react';
import useStyles from './BulkActions.styles';

export interface IAction extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** The label for the action */
  label: string;
}

export interface IBulkActionsProps {
  /** actions to be passed into bulk actions */
  actions: IAction[];
  /** CSS classes applied to the root element of this component. */
  className?: string;
  /** Html id attribute applied to the root element of this component. */
  htmlId?: string;
  /** The current number of selections to display */
  selectionLength?: number;
}

const BulkActions = ({ actions, className, htmlId, selectionLength }: IBulkActionsProps) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)} id={htmlId}>
      {selectionLength !== undefined && (
        <Typography variant="small-text">
          <Locale
            localeKey="dataComponents.itemsSelected"
            params={[<strong>{selectionLength.toString()}</strong>]}
          />
        </Typography>
      )}
      {actions.map((action) => (
        <Button
          key={action.label}
          className={classes.action}
          size={EXTRA_SMALL}
          variant={SECONDARY}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...action}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};

export default BulkActions;
